import React, { useState, useEffect, useRef } from "react";

import {
  CButton,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import "./styles.css";

function InfiniteSelector(props) {
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [showFilter, setShowFilter] = useState(false);

  const containerRef = useRef(null);
  const containerList = useRef(null);
  const numberMaxPages = useRef(0);
  const currentPage = useRef(0);

  const getUsers = async () => {
    setIsLoading(true);
    currentPage.current += 1;

    // Vai receber as props e vou usar elas no obj do POST
    let obj = {
      offset: 10,
      group: props.group,
      region: props.region,
      school: props.school,
      room: props.room
    };

    await axios
      .post(
        `${URL.api}access/user/listByFilterPaginate?page=${currentPage.current}`,
        obj,
        {
          headers: { authorization: `Bearer ${props.user.token}` }
        }
      )
      .then(resp => {
        if (numberMaxPages.current === 0) {
          const arrItems = resp.data.data.user.map(item => ({
            label: item.name,
            value: item.id
          }));
          setItems(arrItems);
          numberMaxPages.current = resp.data.data.meta.last_page;
        } else {
          const arrItems = resp.data.data.user.map(item => ({
            label: item.name,
            id: item.id
          }));
          setItems(prevState => [...prevState, ...arrItems]);
        }
      });
    setIsLoading(false);
  };

  // Em caso de mudança no seletor de Turma
  useEffect(() => {
    setItems([]); // Apaga Itens
    currentPage.current = 0; // Zera a referencia para a página atual
    getUsers(); // Chama para puxar os usuários
  }, [props.flag]);

  const loadMoreItems = () => {
    if (containerList.current.childElementCount <= numberMaxPages.current) {
      getUsers();
    }
  };

  const handleScroll = () => {
    const containerElement = containerRef?.current;
    if (
      containerElement.scrollTop + containerElement.clientHeight >=
      containerElement.scrollHeight
    ) {
      if (!isLoading) {
        loadMoreItems();
      }
    }
  };

  useEffect(() => handleScroll(), [showFilter]);

  useEffect(() => {
    const containerElement = containerRef?.current;
    containerElement?.addEventListener("scroll", handleScroll);
    return () => {
      containerElement?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleItemClick = item => {
    props.handleUserSelected(item);

    if (props.multiSelect) {
      if (selectedItems.includes(item.label)) {
        setSelectedItems(prevSelectedItems =>
          prevSelectedItems.filter(selectedItem => selectedItem !== item.label)
        );
      } else {
        setSelectedItems(prevSelectedItems => [
          ...prevSelectedItems,
          item.label
        ]);
      }
    } else {
      setSelectedItems([item.label]);
      setSearchValue(item.label);
      setShowFilter(false);
    }
  };

  const handleRemoveItem = item => {
    setSelectedItems(prevSelectedItems =>
      prevSelectedItems.filter(selectedItem => selectedItem !== item)
    );
  };

  useEffect(() => {
    props.userSelectorUpdate(items);
  }, [items]);

  useEffect(() => {
    setFilteredItems(items);
  }, [items]);

  useEffect(() => {
    const filtered = items.filter(item =>
      item.label.toLowerCase().startsWith(searchValue.toLowerCase())
    );
    setFilteredItems(filtered);
  }, [searchValue]);

  return (
    <div>
      <CInputGroup className="w-100">
        <CInputGroupPrepend>
          <CInputGroupText>
            <i className="fa fa-text-width"></i>
          </CInputGroupText>
        </CInputGroupPrepend>
        <CInput
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
          placeholder="Pesquisar por nome"
          onFocus={() => setShowFilter(true)}
          className="infinite-selector-input"
          disabled={props.disabled}
        />
        <CButton
          className="dropdown-icon"
          onClick={() => setShowFilter(prevState => !prevState)}
          disabled={props.disabled}
        >
          <i className="fa fa-chevron-down"></i>
        </CButton>
      </CInputGroup>
      <div
        className={showFilter && !props.disabled ? "list-menu mt-1" : "teste"}
      >
        {/* {props.multiSelect && (
            <div style={{ marginBottom: "10px" }}>
              {selectedItems.map((selectedItem, index) => (
                <span key={index} style={{ marginRight: "5px" }}>
                  {selectedItem}
                  <button onClick={() => handleRemoveItem(selectedItem)}>
                    X
                  </button>
                </span>
              ))}
            </div>
          )} */}
        <div className="infinite-selector-container" ref={containerRef}>
          <div ref={containerList}>
            {filteredItems.map((item, index) => (
              <div
                className={`infinite-selector-item ${
                  selectedItems.includes(item.label) &&
                  "infinite-selector-item-selected"
                }`}
                key={index}
                onClick={() => handleItemClick(item)}
              >
                {item.label}
              </div>
            ))}
          </div>
          {isLoading && <p>Carregando...</p>}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InfiniteSelector);
